<template>
    <div>
        <v-cookie></v-cookie>
        <div class="place">
            <span>位置：</span>
            <ul class="placeul">
                <li><a href="#">首页</a></li>
                <li><a href="#">彩信</a></li>
                <li><a href="#">彩信发送</a></li>
            </ul>
        </div>
    
        <div class="formbody"> 
            <div id="usual1" class="usual">
                <div id="tab1" class="tabson">        
                    <div class="formtitle"><span>彩信发送</span></div>    
                    <ul class="forminfo">
                        <li><label>彩信名称/标题</label>
                            <input name="" type="text" v-model="title" class="dfinput" /><i>最长30字，建议15字内并加企业签名</i>
                        </li>
                        <li><label>接收人</label><textarea name="" v-model="mobile" cols="" rows="" class="textinput left"></textarea>
                            <i>限500个以内号码，号码间需以逗号“，”相隔</i>
                        </li>
                        <li><label> &nbsp; </label>
                            <div class="buttonupload  maringht10" @click="addTxl()"> 通讯录导入 </div> 
                            <div class="left"> 
                                 
                                <el-upload
                                    class="upload-demo"
                                    :on-success="uploadSuccess2"
                                    :action=smsTxtUploadUrl
                                    accept=".txt" 
                                    :show-file-list="false"
                                    :headers="uploadHeaders">
                                    <el-button size="small" type="primary">100个及以上号码群发导入</el-button>
                                </el-upload>
                            </div>
                        </li>   

                        <li v-for="(item,index) in mmsInfoList"><label>彩信自助编辑</label>
                            <div class="left" >
                                <dd style="text-align: center; color: #f60;">第{{index+1}}帧</dd>
                                    <dd class=" mms_a">
                                    <img width="200" height="200" :src="item.contentPic"  title="彩信图片">
                                </dd>
                            </div>
                            <div class="left mms_b"> 
                                <dd  class="mms_c">
                                    <span class="left click maringht10">本帧播放时间</span>
                                    <div class="cityleft">
                                        <el-select v-model="item.delay">
                                            <el-option
                                                v-for="item in delayList"
                                                :key="item.value"
                                                :label="item.label"
                                                :value="item.value">
                                            </el-option>
                                        </el-select>
                                    </div>
                                </dd>
                                <dd class="mms_c">
                                    <span class="left maringht10">插入图片</span>
                                    <div class="click maringht10" style="float: left;">
                                        <el-upload
                                            class="upload-demo"
                                            :on-success="uploadSuccess"
                                            :data = "fileUploadParams"
                                            :action="uploadPicUrl(item.frameNum)"
                                            accept="image/jpeg,image/gif" 
                                            :show-file-list="false"
                                            :headers="uploadHeaders">
                                            <el-button size="small" type="primary">上传图片</el-button>
                                        </el-upload>
                                    </div> 
                                    <div v-if="item.picDel" class="buttonupload click1 maringht10" @click="delPic(item.frameNum)">删除</div>
                                    <span class="left">建议图片175*144像素，支持格式jpg,gif</span>
                                </dd>
                                <dd class="mms_c">
                                    <span class="left maringht10">文本插入</span>
                                    <div class="buttonupload click1 maringht10" @click="editTxt(item.frameNum)">文字修改 </div> 
                                    <div class="buttonupload click1 maringht10" @click="delTxt(item.frameNum)">文字删除 </div> 
                                    <span class="left">每帧文字暂限500字（含标点空格）</span>
                                </dd>
                                <dd class="mms_c">
                                    <span class="left ">文字展示：</span><span class="left">{{item.contentTxt}}</span>
                                </dd>
                                <dd class="mms_c">                                    
                                    <div class="buttonupload  click3 maringht10" @click="delMmsP(item.frameNum)">删除本帧 </div>   
                                    <div v-if="index == mmsInfoList.length -1" class="buttonupload  click3 maringht10" @click="addMmsP()">添加一帧</div>                             
                                </dd>

                            </div>
                        </li>

                        <li><label> &nbsp; </label>
                            <!-- <div class="buttonupload click4 maringht10"> 点击查看效果</div>  -->
                            <div class="toolbars lh33">您现在的彩信总大小为:<b>{{allSize}}K</b>，最多5帧，需小于80K </div>
                        </li>

                        <li><label>选择通道</label>
                            <div class="vocation">
                                <el-select v-model="sendMethod" style="width:600px;">
                                    <!-- <el-option  key="10" value="10" label="通道10.显示1069,0.15元/条,三网106彩信产品,只能发手机报,行业,商超会员营销信息"></el-option> -->
                                    <el-option  key="11" value="11" label="通道11.显示1069,0.15元/条,三网106彩信产品,只能发行业,商超会员营销信息"></el-option>
                                </el-select>
                            </div><i  class="toolbars lh33">(温馨提醒：短信末尾均需添加签名;夜间请勿发送太晚，引起投诉） </i>
                        </li>
    
                        <li><label>&nbsp;</label><input class="sure" :disabled="mmsSendDis" type="button" value="提交发送" @click="sendMms()">&nbsp;
                            <input class="cancel" type="button" :disabled="draftDis" value="存到草稿箱" @click="saveDraft()">
                        </li>    
                    </ul>  

                    <div class="jian">&nbsp;</div>
                    <div class="welinfo">
                        <span><img src="../../assets/images/dp.png" alt="提醒" /></span>
                        <b>二办彩信说明</b>
                    </div>
    
                    <ul class="infolist">
                        <li><span>彩信的英文名是MMS，它是Multimedia Messaging Service的缩写，意为多媒体信息服务，通常又称为彩信。</span></li> 
                        <li><span>优点：</span></li> 
                        <li><span>图文并茂:彩信配有丰富的彩色图片、声音、动画、震动等多媒体的内容，图文并茂，生动直观。时尚新颖，客户新鲜感强。</span></li>
                        <li><span>大容量：容量为80K的彩信，相当于8幅精美图片或2万多个汉字，这是原本只有70个汉字的普通短信无法比拟的，全面传达企业形象和销售信息，有助于商家从纷繁喧嚣的传播环境中脱颖而出。</span></li>
                        <li><span>自由，直投：彩信广告的发布时间可以自由控制,不受传统广告制作、发行周期的影响，直接投放。</span></li>
                        <li><span>再营销：制作精美的彩信广告用户更是会保存甚至转发给相关有需要的亲朋好友查阅，能起到长远的效益。</span></li>
                        <li><span>多媒体彩信手机越来越普及，是发送产品介绍、祝福、资讯的好帮手</span></li>
                        <li><span>注意：</span></li>
                        <li><span>1、彩信总体积不要超过80K，否则有些手机可能不能正常接收。</span></li>
                        <li><span>2、制作:彩信以“帧”为页面单位，每帧可以放置一张图片和对应文字信息。</span></li>
                        <li><span>图片格式：jpg、gif；广告图片尺寸：176*144像素（推荐）;动态gif图最好不要超过2张;音频格式：MIDI； 全文字可以发送2万多字。</span></li>
                        <li><span>建议事先备好脚本及素材，支持在线自助编辑,只需按指导上传素材即可(类似做PPT)。代制作费用 80元/个; 动画另计</span></li>
                        <li><span>3、收费:0.18-0.2元/条。发送按提交收费。小部分老款手机因不支持彩信或网络问题，将可能收不到您发送的彩信,费用恕不退还</span></li>
                    </ul>
    
                </div> 
	        </div> 
 

            <!--弹出框-->

            <!--图片上传-->
    
            <div class="tip tip2 ">
                <div class="tiptop"><span>图片上传</span><a></a></div>
                
                <div class="cen ovhi pat20">
                    <input name="" type="text" class="scinput" style="width:280px;"/>
                    </div>
                    
                    <div class="cen lh33 ovhi">建议图片175*144像素，支持格式jpg,gif</div>
                    
                    <div class="cen pat20 ovhi">
                    <input name="" type="button"  class="sure"  value="确定添加" />&nbsp;
                    <input name="" type="button"  class="cancel"  value="取消" />
                </div>
                
            </div>

            <!--文字内容-->

            <div class="tip tip1 ">
                <div class="tiptop"><span>文字内容</span><a></a></div>
                
                <div class="cen ovhi pat20">
                <textarea name="" cols="" rows="" v-model="contentTxt" class="textinput" style="width: 380px;"></textarea>
                </div>
                
                <div class="cen lh33 ovhi">字符暂限500字符内（含标点空格）</div>
                
                <div class="cen pat20 ovhi">
                <input name="" type="button"  class="sure" @click="okEditTxt()"  value="确定添加" />&nbsp;
                <input name="" type="button"  class="cancel" @click="cancelEditTxt()"  value="取消" />
                </div>  
            </div>

            <!--确定删除-->

            <div class="tip tip3 ">
                <div class="tiptop"><span>确定删除</span><a></a></div>
                
                <div class="cen ovhi pat20">
                </div>
                
                <div class="cen lh33 ovhi">是否确定删除，删除后无法恢复。</div>
                
                <div class="cen pat20 ovhi">
                    <input name="" type="button"  class="sure"  value="确定添加" />&nbsp;
                    <input name="" type="button"  class="cancel"  value="取消" />
                </div>                        
            </div>

            <!--确定删除-->

            <div class="tip tip4 ">
                <div class="tiptop"><span>查看效果</span><a></a></div>
                
                <div class="cen ovhi pat20">
                </div>
                
                <div class="cen lh22 ovhi">
                <div class="phone">
                <div class="mms_d" >图片展示</div>  
                <span>每帧文字暂限500字每帧文字暂限</span>
                </div>
                </div>
                
                <div class="cen pat20 ovhi">
                <input name="" type="button"  class="sure"  value="关闭" />
            
                </div>                
            </div>

            <!--tip1 通讯录-->
            <div class="tip tip5">        
                <div class="tiptop"><span>第二办公室-通讯录</span><a></a></div>        
                <div class="tipinfo cen ovhi">      
                    <div class="cen ovhi">
                        <label class="left lh33">选择组 &nbsp; </label>
                        <div class="cityleft">
                            <el-select v-model="txlgroupid" @change="pageChangeTxl()" placeholder="请选择">
                                <el-option label="全部" value=""></el-option>
                                <el-option
                                    v-for="item in txlGroupList"
                                    :key="item.groupid"
                                    :label="item.groupname"
                                    :value="item.groupid">
                                </el-option>
                            </el-select>
                        </div>
                    </div>        
                    <table class="tablelist">
                        <thead>
                            <tr>
                                <th>
                                    <input name="allCheck" id="allCheck" @click="changAllCheck()" type="checkbox" value=""/>
                                </th>
                                <th>姓名</th>
                                <th>号码</th>
                            </tr>
                        </thead>
                        <tbody>    
                            <tr>
                                <td colspan="3" v-show="isSearch">查询中....</td>
                            </tr>    
                            <tr v-for="item in txlContList">
                                <td><input name="txlmphone1" type="checkbox" :value="item.name + '{'+item.mphone1.trim()+'}'" /></td>
                                <td>{{item.name}}</td>
                                <td>{{item.mphone1}}</td>
                            </tr>
                        </tbody>
                    </table>        
                    <div class="cen pat20 ovhi">
                        <input name="" type="button"  class="sure" @click="checkok()"  value="确定" />&nbsp;
                        <input name="" type="button"  class="cancel" @click="close()"  value="取消" />
                    </div>    
                </div>    
            </div>
            <!--tip1 end-->
        </div>
    </div>
   
</template>
<script>
import cookie from '@/components/cookie.vue'
import defaultMmsPic from '../../assets/images/200.jpg'
export default {
    components : {
        'v-cookie' : cookie,
    },
    data(){
        return{
            mmsImgUploadUrl:'',
            uploadHeaders:{},
            mmsInfoList:[],
            mmsid:'',
            fileUploadParams:{'mmsid':''},
            allSize:0,
            frameNum:0,
            contentTxt:'',
            title:'',
            mobile:'',
            formart:'phone',
            txtpath:'',
            sendMethod:'11',
            delayList:[
                {value:'1000',label:'1秒'},{value:'3000',label:'3秒'},{value:'5000',label:'5秒'},
                {value:'10000',label:'10秒'},{value:'30000',label:'30秒'},{value:'60000',label:'1分钟'}
            ],
            smsTxtUploadUrl:this.GLOBAL.serverSrc + '/sms/uploadsmstxt.json',
            txlGroupList:[],
            txlgroupid:'',
            txlContList:[],
            txmobile:'',
            isSearch:true,
            srcFileName:'',
            mmsSendDis: false,
            draftDis: false,
        }
    },
    mounted(){
        this.initPage();
        this.uploadHeaders.token = this.GLOBAL.token;
    },
    methods:{
        initPage(){
            if(this.mmsInfoList.length == 0){
                this.mmsInfoList.push({'frameNum':0,'contentTxt':'','txtSize':0,'txtDel':false,'contentPic':defaultMmsPic,'picName':'','picSize':0,'picDel':false,'contentAudio':'','audioName':'','audioSize':0,'delay':'5000'});
            }
            var date = new Date();
            this.mmsid = date.getTime();
            this.fileUploadParams.mmsid = this.mmsid;
        },
        uploadSuccess(response){
            if('0000000' == response.code)
            {
                //console.log('http://localhost:8080/' + response.filePath);
                // this.mmsInfoList[response.frameNum].contentPic = 'http://localhost:8080/' + response.filePath;
                this.mmsInfoList[response.frameNum].contentPic = 'http://www.2office.cn:8000/' + response.filePath;
                this.mmsInfoList[response.frameNum].picSize = response.size;
                this.mmsInfoList[response.frameNum].picDel = true;
            }
            this.resetAllSize();
        },
        uploadSuccess2(response){
            if (response.code === '0000000') {
                this.txtpath = response.txtPath;
                this.formart = "txt";
                this.srcFileName = response.srcFileName;
                this.mobile = "您的号码文件" + response.srcFileName + "上传成功，请填写内容发送."
            }
            else if("0000006" == response.code){
                // this.buttonDisabled = false
                this.$alert(response.message, '格式错误，文件必须是txt格式！', {
                    confirmButtonText: '确定'
                })
                this.$refs.upload.clearFiles()
            }
            else{
                alert(response.msg);
            }
        },
        showMmsFram(){

        },
        uploadPicUrl(frameNum){
            return this.GLOBAL.serverSrc + '/mms/uploadmmspic.json?frameNum=' + frameNum
            
        },
        resetAllSize(){
            this.allSize = 0;
            this.mmsInfoList.forEach(obj => {
                this.allSize = this.allSize + obj.txtSize + obj.picSize + obj.audioSize;
                
            });
            this.allSize = parseFloat((this.allSize/1024).toFixed(3))
        },
        editTxt(frameNum){
            $(".tip1").fadeIn(200);
            $(".tiptop a").click(function(){
                $(".tip1").fadeOut(200);
            })
            this.frameNum = frameNum;
            this.contentTxt = '';
        },
        cancelEditTxt(){
            $(".tip1").fadeOut(200);
            this.frameNum = 0;
        },
        okEditTxt(){
            if(this.contentTxt.trim().length == 0){
                alert("内容不能为空！");
                return;
            }
            if(this.contentTxt.trim().length > 500){
                alert("内容长度不能超过500！");
                return;
            }
            let that = this;
            let data = {'frameNum':this.frameNum,'contentTxt':this.contentTxt,'mmsid':this.mmsid};
            this.$ajax({
                method: 'post',
                url: this.GLOBAL.serverSrc + '/mms/editmmstxt.json',
                data: data,
                headers: {
                    'Content-Type': 'application/json; charset=UTF-8',
                    'token' : this.GLOBAL.token
                }
            }).then(function(res) {
                if('0000000' == res.data.code)
                {
                    var contentTxt = res.data.contentTxt;
                    that.mmsInfoList[res.data.frameNum].contentTxt = contentTxt;
                    that.mmsInfoList[res.data.frameNum].txtSize = res.data.size;
                    that.resetAllSize();
                    that.cancelEditTxt();
                }
                else
                {
                    alert(res.data.msg)
                }
            })
        },
        delMmsP(frameNum){            
            let that = this;
            let data = {'frameNum':frameNum,'mmsid':this.mmsid};
            this.$ajax({
                method: 'post',
                url: this.GLOBAL.serverSrc + '/mms/delmmsprocess.json',
                data: data,
                headers: {
                    'Content-Type': 'application/json; charset=UTF-8',
                    'token' : this.GLOBAL.token
                }
            }).then(function(res) {
                if('0000000' == res.data.code)
                {
                    var newList = that.mmsInfoList.filter(function(obj){
                        return obj.frameNum != frameNum;
                    })
                    that.mmsInfoList = newList;
                    if(that.mmsInfoList.length == 0){
                        that.mmsInfoList.push({'frameNum':0,'contentTxt':'','txtSize':0,'contentPic':defaultMmsPic,'picName':'','picSize':0,'contentAudio':'','audioName':'','audioSize':0,'delay':'5000'});
                    }
                    that.resetAllSize();
                }
                else
                {
                    alert(res.data.msg)
                }
            })
        },
        addMmsP(){
            let frameNum = this.mmsInfoList.length;
            if(frameNum >= 5)
            {
                alert("最多只支持5帧");
			    return;
            }
            this.mmsInfoList.push({'frameNum':frameNum,'contentTxt':'','txtSize':0,'contentPic':defaultMmsPic,'picName':'','picSize':0,'contentAudio':'','audioName':'','audioSize':0,'delay':'5000'});
        },
        delPic(frameNum){
            let that = this;
            let data = {'frameNum':frameNum,'mmsid':this.mmsid};
            this.$ajax({
                method: 'post',
                url: this.GLOBAL.serverSrc + '/mms/delmmspic.json',
                data: data,
                headers: {
                    'Content-Type': 'application/json; charset=UTF-8',
                    'token' : this.GLOBAL.token
                }
            }).then(function(res) {
                if('0000000' == res.data.code)
                {
                    that.mmsInfoList[response.frameNum].contentPic = defaultMmsPic;
                    that.mmsInfoList[response.frameNum].picSize = 0;
                    that.mmsInfoList[response.frameNum].picDel = false;
                    that.resetAllSize();
                }
                else
                {
                    alert(res.data.msg)
                }
            })
        },
        delTxt(frameNum){
            let that = this;
            let data = {'frameNum':frameNum,'mmsid':this.mmsid};
            this.$ajax({
                method: 'post',
                url: this.GLOBAL.serverSrc + '/mms/delmmstxt.json',
                data: data,
                headers: {
                    'Content-Type': 'application/json; charset=UTF-8',
                    'token' : this.GLOBAL.token
                }
            }).then(function(res) {
                if('0000000' == res.data.code)
                {
                    that.mmsInfoList[frameNum].contentTxt = '';
                    that.mmsInfoList[frameNum].txtSize = 0;
                    that.resetAllSize();
                }
                else
                {
                    alert(res.data.msg)
                }
            })
        },
        sendMms(){
            if(this.title.trim() == ''){
                alert("彩信标题不能为空！");
                return;
            }
            if(this.title.trim().length > 30)
            {
                alert("彩信标题长度不能超过30！");
                return;
            }
            if(this.mobile.trim() ==''){
                alert("号码不能为空！");
                return;
            }
            if(this.allSize <= 0){
                alert("帧信息不能为空！");
                return;
            }
            if(this.allSize > 80){
                alert("彩信总大小不能超过80K！");
                return;
            }
        
            var delays = '';
            this.mmsInfoList.forEach(obj => {
                if(delays == '')
                    delays = obj.delay + ";" + obj.frameNum;
                else
                    delays = delays + "," + obj.delay + ";" + obj.frameNum;
            });
            this.mmsSendDis = true;
            let that = this;
            let data = {'title':this.title,'mobile':this.mobile,'formart':this.formart,'srcFileName':this.srcFileName,'txtpath':this.txtpath,'mmsid':this.mmsid,'sendMethod':this.sendMethod,'delays':delays,'allSize':this.allSize};
            this.$ajax({
                method: 'post',
                url: this.GLOBAL.serverSrc + '/mms/sendmms.json',
                data: data,
                headers: {
                    'Content-Type': 'application/json; charset=UTF-8',
                    'token' : this.GLOBAL.token
                }
            }).then(function(res) {
                if('0000000' == res.data.code)
                {
                    alert("彩信已提交成功，客服审核后自动发送，切勿重复提交！！");
                    that.$router.push('/mmscheck')
                }
                else
                {
                    alert(res.data.msg)
                }
            })
        },
        addTxl(){
            $(".tip5").fadeIn(200);
            $(".tiptop a").click(function(){
                $(".tip5").fadeOut(200);
            })
            this.pageChangeTxl();
        },
        pageChangeTxl(){
            var that = this
            let data = {'groupid':this.txlgroupid}
            this.$ajax({
                method: 'post',
                url: this.GLOBAL.serverSrc + '/txl/gettxlcontmphone.json',
                data: data,
                headers: {
                    'Content-Type': 'application/json; charset=UTF-8',
                    'token' : this.GLOBAL.token
                }
            }).then(function(res) {
                if('0000000' == res.data.code)
                {
                    that.txlContList = res.data.txlContList;
                    that.txlGroupList = res.data.txlGroupList;
                    that.isSearch = false;
                }
                else
                {
                    alert(res.data.msg)
                }
            })            
        },
        changAllCheck(){
            var checkers = document.getElementsByName('txlmphone1');
            if (document.getElementById("allCheck").checked == true)
            {
                for ( var i = 0; i < checkers.length; i++)
                {
                    checkers[i].checked = true;
                }
            }
            else
            {
                for ( var i = 0; i < checkers.length; i++)
                {
                    checkers[i].checked = false;
                }
            }
        },
        checkok(){
            var info = '';
            var checkers = document.getElementsByName('txlmphone1');
            for ( var i = 0; i < checkers.length; i++){
                if(checkers[i].checked){
                    if(info =='')
                        info = checkers[i].value;
                    else
                        info = info + ',' + checkers[i].value;
                }
            }
            if(this.mobile == '')
                this.mobile = info;
            else
                this.mobile = this.mobile + "," + info;
            this.closeTxl();
        },
        closeTxl(){
            $(".tip5").fadeOut(200);
        },
        saveDraft(){
            if(this.title.trim() == '' && this.mobile.trim() == '' && this.allSize <= 0){
                alert("彩信主题或者接收者号码或者彩信帧至少有一项不能为空！");
                return;
            }
            let delays = '';
            this.mmsInfoList.forEach(obj => {
                if(delays == '')
                    delays = obj.delay + "," + obj.frameNum;
                else
                    delays = delays + ";" + obj.delay + "," + obj.frameNum;
            });
            this.draftDis = true;
            var that = this;
            let data = {'mmsid':this.mmsid,'title':this.title,'formart':this.formart,'mobile':this.mobile,'txtpath':this.txtpath,'delays':delays}
            this.$ajax({
                method: 'post',
                url: this.GLOBAL.serverSrc + '/mms/savemmsdraft.json',
                data: data,
                headers: {
                    'Content-Type': 'application/json; charset=UTF-8',
                    'token' : this.GLOBAL.token
                }
            }).then(function(res) {
                if('0000000' == res.data.code)
                {
                    alert("彩信保存到草稿箱成功！")
                }
                else
                {
                    alert(res.data.msg)
                }
                that.draftDis = false;
            })  
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/mms/mmssend.vue